<div class="form-row">
  <div class="form-group col-md-6">
    <label>Customer</label>
    <select name='accountId' [(ngModel)]='this.rate.accountId' [class.is-invalid]='!this.rate.accountId || this.rate.accountId === -1' class="form-control">
      <option [ngValue]='-1'>-- select a customer --</option>
      @for (account of this.accounts; track account.id) {
        <option [ngValue]='account.id'>{{ account.name }}</option>
      }
    </select>
  </div>

  <div class="form-group col-md-6">
    <label>Charged per</label>
    <select name='unitId' [(ngModel)]='this.rate.unitId' [class.is-invalid]='!this.rate.unitId || this.rate.unitId === -1' class="form-control">
      <option [ngValue]='-1'>-- select a unit --</option>
      @for (unit of this.units; track unit.id) {
        <option [ngValue]='unit.id'>{{ unit.name }}</option>
      }
    </select>
    <small class='form-text text-muted'>The measure the rate was agreed in &mdash; tonnes for bulk, pallets where stock is counted that way.</small>
  </div>

  <div class="form-group col-md-6">
    <label>Storage rate (per unit, per day)</label>
    <input type="number" step="0.0001" min="0" name='storageRatePerDay' [(ngModel)]='this.rate.storageRatePerDay' [class.is-invalid]='this.rate.storageRatePerDay === null || this.rate.storageRatePerDay < 0' class="form-control">
  </div>

  <div class="form-group col-md-6">
    <label>RH&amp;D rate (per unit)</label>
    <input type="number" step="0.0001" min="0" name='rhdRate' [(ngModel)]='this.rate.rhdRate' [class.is-invalid]='this.rate.rhdRate === null || this.rate.rhdRate < 0' class="form-control">
    <small class='form-text text-muted'>Charged once on receipt only.</small>
  </div>

  <div class="form-group col-md-6">
    <label>Effective from</label>
    <input type="date" name='effectiveFrom' [(ngModel)]='this.rate.effectiveFrom' [class.is-invalid]='!this.rate.effectiveFrom' class="form-control">
    <small class='form-text text-muted'>This rate applies from this day until a later rate supersedes it.</small>
  </div>

  <div class="form-group col-md-6">
    <label>Product override <span class='text-muted'>(optional)</span></label>
    <select name='productId' [(ngModel)]='this.rate.productId' class="form-control">
      <option [ngValue]='null'>All products</option>
      @for (product of this.products; track product.id) {
        <option [ngValue]='product.id'>{{ product.name }}</option>
      }
    </select>
    <small class='form-text text-muted'>Leave as "All products" unless this one product is priced differently.</small>
  </div>
</div>
